import React from 'react';
import PropTypes from 'prop-types';
import codeSplitLoad from 'Webapp/shared/utils/code-split-load';
import classNames from 'classnames';
import styled from '@emotion/styled';

import StoryboardStructuredData from '../../structured-data/storyboard';
import PageClasses from '../../components/page-classes';
import CTABannerRedesigned from '../../components/cta-banner-redesigned';

import connector from 'Utils/connector';
import connectAmp from 'Webapp/shared/app/connectors/connectAmp';
import connectFlipMode from 'Webapp/shared/app/connectors/connectFlipMode';

import { LAYOUT_SIZES } from 'Style/layout';

const StoryboardLayout = codeSplitLoad('StoryboardLayout');
const StoryboardPreviewFooter = codeSplitLoad('StoryboardPreviewFooter');

const StyledStoryboardSection = styled.div((props) => ({
  marginTop: props.isFlipModeEnabled
    ? `-${LAYOUT_SIZES.MAIN_NAV_PLUS_FLIP_MODE_HEIGHT}`
    : null,
}));

const Storyboard = ({
  section,
  storyboardSkeleton,
  loadNextPage,
  neverLoadMore,
  isLoading,
  items,
  userid,
  relatedArticlesSection,
  relatedTopicsSections,
  isFlipModeEnabled,
}) => {
  const isOwnStoryboard = section.userid === userid;

  const classes = classNames({
    'storyboard-layout': true,
    'storyboard-layout-storyboard-theme': true,
  });

  return (
    <StyledStoryboardSection
      className={classes}
      isFlipModeEnabled={isFlipModeEnabled}
    >
      <PageClasses enableFullWidth isFlipModeEnabled={isFlipModeEnabled}>
        <StoryboardStructuredData section={section} />
        <StoryboardLayout
          section={section}
          items={items}
          relatedArticlesSection={relatedArticlesSection}
          relatedTopicsSections={relatedTopicsSections}
          loadNextPage={loadNextPage}
          isLoading={isLoading}
          neverLoadMore={neverLoadMore}
        />
        <CTABannerRedesigned />

        {isOwnStoryboard && (
          <StoryboardPreviewFooter
            section={section}
            isOwnStoryboard={isOwnStoryboard}
            storyboard={storyboardSkeleton}
          />
        )}
      </PageClasses>
    </StyledStoryboardSection>
  );
};

Storyboard.propTypes = {
  section: PropTypes.object.isRequired,
  storyboardSkeleton: PropTypes.object,
  userid: PropTypes.number,
  loadNextPage: PropTypes.func.isRequired,
  neverLoadMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  relatedArticlesSection: PropTypes.object,
  relatedTopicsSections: PropTypes.arrayOf(PropTypes.object),
  isAmp: PropTypes.bool,
  isFlipModeEnabled: PropTypes.bool.isRequired,
};

Storyboard.defaultProps = {
  userid: 0,
  storyboardSkeleton: null,
  relatedArticlesSection: null,
  relatedTopicsSections: [],
  isAmp: false,
};

export default connector(connectAmp, connectFlipMode)(Storyboard);
